const BASE_URL =
  typeof window === "undefined"
    ? process.env.API_INTERNAL_BASE_URL
    : process.env.NEXT_PUBLIC_API_BASE_URL;

const BASE_RPC_URL =
  typeof window === "undefined"
    ? process.env.API_INTERNAL_BASE_RPC_URL
    : process.env.NEXT_PUBLIC_API_BASE_RPC_URL;

export const apiConfig = {
  baseUrl: BASE_URL || "/",
  baseRpcUrl: BASE_RPC_URL || `${BASE_URL}/rpc`,
};
